export default __webpack_public_path__ + "static/media/pabe_ghat.13a25f0b.png";